import { FC } from 'react';
import {
  CreateButton,
  Datagrid,
  DateField,
  EditButton,
  List,
  ReferenceField,
  TextField,
  TopToolbar,
  BooleanField,
  FunctionField,
} from 'react-admin';

const ListActions = () => (
  <TopToolbar>
    <CreateButton label="Добавить материал" />
  </TopToolbar>
);

export const MaterialList: FC = () => (
  <List title="Список материалов" filter={{}} actions={<ListActions />}>
    <Datagrid rowClick="edit">
      <TextField source="id" label="ID" />
      <ReferenceField
        source="feed_id"
        reference="feeds"
        label="Лента"
        emptyText="Нет ленты"
      >
        <TextField source="name" />
      </ReferenceField>
      <TextField source="name" label="Название" />
      <FunctionField
        label="Мин. тариф"
        render={(record: any) => {
          if (!record.min_tariff) return 'Все';
          const tariffNames: Record<string, string> = {
            start: 'Start',
            easy_start: 'Easy Start',
            mashtab: 'Mashtab',
            platina: 'Platina',
            vip: 'VIP',
          };
          return tariffNames[record.min_tariff] || record.min_tariff;
        }}
      />
      <FunctionField
        label="Есть транскрибация"
        render={(record: any) => (record.transcript ? '✅' : '❌')}
      />
      <DateField
        source="updated_at"
        label="Дата обновления"
        showTime={true}
        locales="ru-RU"
      />
      <EditButton label="Редактировать" />
    </Datagrid>
  </List>
);
